const bg = {
  translation: {
    language: { label: 'Език на интерфейса', ru: 'Руски', en: 'English', bg: 'Български' },
    navigation: {
      close: 'Затвори',
      account: 'Личен кабинет',
      products: 'Продукти / Лицензи',
      finance: 'Моите финанси',
      calculator: 'Калкулатор',
      partners: 'За партньори',
      events: 'Събития',
      profile: 'Лични данни',
      support: 'Поддръжка',
      promo: 'Промо',
      vps: 'VPS',
      logout: 'Изход',
    },
    header: { promotion: 'Промоция', balance: 'Баланс', technicalSupport: 'Техническа поддръжка', mentor: 'Наставник' },
    profile: {
      main: 'Основна информация',
      fullName: 'Три имена',
      loginUsername: 'Логин (потребителско име)',
      birthDate: 'Дата на раждане',
      country: 'Държава',
      email: 'Имейл',
      phone: 'Телефон',
      telegram: 'Telegram',
      security: 'Сигурност',
      transactionConfirmation: 'Потвърждение на операции',
      changePassword: 'Смяна на парола',
      currentPassword: 'Текуща парола',
      newPassword: 'Нова парола',
      confirmNewPassword: 'Потвърдете новата парола',
      enterOldPassword: 'Въведете старата парола',
      enterNewPassword: 'Въведете новата парола',
      confirmPassword: 'Потвърдете паролата',
      invalidPasswordCharacter: 'Използван е невалиден символ. Разрешени са: латински букви, цифри и !@#$%^&*()-+',
      passwordComplexity: 'Паролата трябва да съдържа поне 2 от 4: малки букви, главни букви, цифри, специални символи',
      passwordsMustMatch: 'Паролите трябва да съвпадат!',
      save: 'Запази',
      lastName: 'Фамилия',
      firstName: 'Име',
      middleName: 'Презиме',
      enterLastName: 'Въведете фамилия',
      enterFirstName: 'Въведете име',
      enterMiddleName: 'Въведете презиме',
      lastNameExample: 'Иванов',
      firstNameExample: 'Иван',
      middleNameExample: 'Иванов',
      phoneFormat: 'Телефонът трябва да е във формат +79997768879',
      phoneLength: 'Телефонът трябва да съдържа от 11 до 15 цифри',
      telegramRequirements:
        'Telegram трябва да съдържа само латински символи, да започва с @ и да е с дължина от 5 до 31 символа',
      enterPhoneNumber: 'Въведете телефонния си номер',
      enterTelegramNickname: 'Въведете потребителското си име в Telegram',
      countryPlaceholder: 'Гърция',
      moscow: 'Москва',
      confirmationByEmail: 'По имейл',
      googleAuthenticator: '2FA Google Authenticator',
      error: 'Грешка',
      phoneRequiredForTwoFactor: 'Добавете телефонен номер в настройките на профила си.',
    },
    verification: {
      title: 'Верификация',
      passportPhotoRequired: 'За верификация на акаунта е необходимо да изпратите снимка на паспорта',
      instruction: 'Инструкции',
      takePhotoAsExample: 'Направете снимка както в примера',
      addPhotoToForm: 'Добавете снимката във формуляра',
      sendForReviewInstruction: 'Натиснете бутона „Изпратете за проверка“',
      mainPassportSpread: '1. Основна страница на паспорта',
      registrationAddress: '2. Адресна регистрация',
      addPhoto: 'Добавете снимка',
      chooseFile: 'Изберете файл',
      photoRequirements: 'Изисквания към снимката',
      takesUpToFiveDays: 'Верификацията отнема до 5 дни',
      send: 'Изпратете',
      sendForReview: 'Изпратете за проверка',
      documentsUnderReview: 'Документите се проверяват',
      verificationError: 'Грешка при верификацията',
      repeatVerificationRequired: 'Необходимо е да преминете верификацията отново',
      repeatVerification: 'Преминете верификацията отново',
      startVerification: 'Преминете верификация',
    },
    accountRemoval: {
      removeAllData: 'Изтрийте акаунта и всички данни',
      title: 'Изтриване на акаунт',
      confirmation: 'Сигурни ли сте, че искате да изтриете акаунта и всички данни? ',
      remove: 'Изтрийте',
      informationalNotice: 'Информационно известие',
      reasonNoLongerClient: 'Вече не искам да бъда клиент',
      reasonAnotherAccount: 'Искам да създам друг акаунт',
      reasonOther: 'Други причини',
      warnings: 'Предупреждения',
      warningIrreversible: 'След изтриване на личния си акаунт няма да можете да възстановите данните',
      warningBalance: 'Целият ви напредък и средствата по баланса ще бъдат изтрити',
      warningProducts: 'Вече няма да можете да използвате продуктите на компанията, закупени за този акаунт',
      warningsAcknowledged: 'Запознах се с предупрежденията',
      codeSentToEmail: 'Въведете кода, който ви изпратихме по имейл',
      removeAccount: 'Изтрийте акаунта',
    },
    finance: {
      balance: 'Баланс:',
      processing: 'В обработка:',
      inProcessing: 'В обработка',
      withdrawn: 'Изтеглено:',
      transactionHistory: 'История на транзакциите',
      completed: 'Изпълнено',
      cancelled: 'Отказано',
      transactionId: 'ID на транзакцията',
      recipient: 'Получател',
      sender: 'Изпращач',
      description: 'Описание',
      paymentMethod: 'Начин на плащане',
      cancelTransaction: 'Откажете транзакцията',
      noTransactions: 'Няма транзакции',
      cancellationConfirmation: 'Потвърдете отказването на транзакцията',
      yes: 'Да',
      filter: 'Филтър',
      byDate: 'По дата',
      enterUsername: 'Въведете потребителско име',
      enterDescription: 'Въведете описание',
      selectPaymentMethod: 'Изберете начин на плащане',
      show: 'Покажи',
      purchase: 'Покупка',
      withdrawal: 'Теглене',
      matchingBonus: 'Мачинг бонус',
      companyReward: 'Възнаграждение от компанията',
      other: 'Друго',
      withdrawalNotice: 'Тегленето може да отнеме до два работни дни ',
      instruction: 'Инструкции',
      withdrawalStepDetails: 'Въведете мрежата, посочете адреса и сумата за теглене',
      withdrawalStepVerify: 'Потвърдете коректността на данните ',
      withdrawalStepConfirm: 'Потвърдете транзакцията ',
      chooseCoin: 'Изберете монета',
      coin: 'Монета',
      chooseNetwork: 'Изберете мрежа',
      cryptocurrencyNetwork: 'Криптовалутна мрежа',
      walletAddressInNetwork: 'Въведете адреса на портфейла в избраната мрежа',
      enterWalletAddress: 'Въведете адреса на портфейла',
      enterAmount: 'Въведете сума',
      minimumWithdrawalAmount: 'Минимална сума за теглене: {{amount}}',
      minimumWithdrawalError: 'Минимална сума за теглене: {{amount}} USDT',
      walletLengthError: 'Адресът на портфейла надвишава 50 символа',
      invalidAmount: 'Въвели сте невалидна сума',
      invalidIntegerAmount: 'Въвели сте невалидна сума. Сумата за теглене трябва да е цяло число',
      insufficientFunds: 'Нямате достатъчно средства по сметката',
      withdrawBonuses: 'Изтеглете бонусите',
    },
    notifications: {
      title: 'Известия',
      empty: 'Няма известия',
      dateTime: '{{date}} в {{time}}',
    },
    events: {
      online: 'Онлайн',
      offline: 'Офлайн',
      readMore: 'Прочетете повече',
      title: 'Събития',
      back: 'Назад',
      nextArticle: 'Следваща статия',
      futureEvents: 'Предстоящи събития',
      pastEvents: 'Минали събития',
    },
    marketing: {
      title: 'Маркетинг',
      description:
        'В този раздел можете да се запознаете с всички правила и условия за начисляване на възнаграждения за популяризиране на продуктите на компанията, както и с необходимата информация за изграждане на онлайн бизнес.',
      companyPlanTitle: 'Маркетингов план на компанията FT Holding Trade',
      companyPlanDescription:
        'В този раздел можете да се запознаете с всички правила и условия за начисляване на възнаграждения за популяризиране на продуктите на компанията, както и с необходимата информация за изграждане на онлайн бизнес.',
      goTo: 'Към раздела',
      readMore: 'Прочетете повече',
      materials: {
        fastStart: {
          title: 'Бонус за бърз старт',
          summary:
            'Това е допълнителен процент за лични препоръки. За да получите бонуса за бърз старт, трябва да закупите 1, 3 или 5 търговски системи...',
          sections: [
            `Това е допълнителен процент за лични препоръки.

За да получите бонуса за бърз старт, трябва да закупите 1, 3 или 5 търговски системи.
Компанията предлага и бонус за бърз старт, който е валиден през първите 30 дни след закупуването на търговска система.

При закупуване на една търговска система получавате допълнителен доход от 3% от всяка лична продажба.

Ако закупите 3 търговски системи, получавате допълнителен доход от 6% от всяка лична продажба. При закупуване на 5 търговски системи получавате допълнителен доход от 9% от всяка лична продажба.`,
          ],
        },
        matchingBonus: {
          title: 'Матчинг бонус',
          summary:
            'Матчинг бонусът ви се изплаща от всяка продажба във вашата структура. От 5-о ниво всеки партньор получава статут на директор...',
          sections: [
            `Матчинг бонусът ви се изплаща от всяка продажба във вашата структура.
От 5-о ниво всеки партньор получава статут на директор...
Той получава уникален ID на структурата и матчинг бонус.
Матчинг бонусът ви се изплаща от всяка продажба във вашата структура.
Този бонус се изплаща заедно с екипния бонус.
Размерът му е от 0,5% до 5% от всяка продажба в зависимост от нивото.
Когато във вашата структура се появи още един директор от 5-о ниво, той също започва да получава матчинг бонус от своята структура и така за вас се образува разлика в дохода.
Ако вашият партньор е на 5-о ниво, той получава 0,5% матчинг бонус от цялата си структура.
Тогава вие ще получавате своя процент минус тези 0,5% от неговия структурен клон.
Ако партньорът е на 6-о ниво, той получава 1% матчинг бонус от своята структура, а вие получавате с 1% по-малко от тази структура.
Ако партньор под вас достигне същото кариерно ниво като вас, спирате да печелите от неговата структура, защото между нивата ви вече няма разлика и този партньор получава всички бонуси.
Това условие важи както за екипния, така и за матчинг бонуса.`,
          ],
        },
        units: {
          title: 'Изчисляване на единиците',
          summary:
            'В компанията има рангова система, наречена Кариерни нива. Кариерните нива се достигат чрез продажба на продуктите на компанията от вас и вашите партньори...',
          sections: [
            `В компанията има рангова система, наречена Кариерни нива. Кариерните нива се достигат чрез продажба на продуктите на компанията от вас и вашите партньори.

За да преминете към следващото ниво, трябва да натрупате определен брой Единици.

Единицата е мярка, която показва оборота на партньора и неговия екип в компанията и определя нивото, на което трябва да се намира всеки партньор според своя оборот.`,
            `Компанията използва формула, чрез която можете да изчислите колко Единици ще получите от продажбата на който и да е продукт на компанията.

ЦЕНА НА ПРОДУКТА / 500 = брой Единици.

С други думи, сумата на покупката на клиента се разделя на коефициент 500 и така получавате броя Единици за реализирания оборот.
Как се изчисляват оборотът и Единиците?

Компанията използва формула, чрез която можете да изчислите колко Единици ще получите от продажбата на който и да е продукт на компанията.

ЦЕНА НА ПРОДУКТА / 500 = брой Единици.

С други думи, сумата на покупката на клиента се разделя на коефициент 500 и така получавате броя Единици за реализирания оборот.`,
          ],
        },
        career: {
          title: 'Как да отключите кариерата във FT Holding Trade',
          summary:
            'Първото условие е активен статус, който ви дава достъп до бизнеса и възможност за кариерно развитие. Второто условие е притежаването на търговски системи, които отключват всички нива на маркетинговия план на компанията. Компанията има две условия: активен статус за достъп до бизнеса и кариерно развитие и търговски системи за отключване на всички нива на маркетинговия план.',
          sections: [
            `Нека разгледаме по-подробно първото условие:

Кариерната програма има 11 нива, започвайки от ниво 0 и завършвайки с ниво 10.

За да получите ниво 0, е достатъчно да регистрирате профил чрез рефералната връзка на партньор на компанията. Веднага след регистрацията можете да започнете да развивате бизнес и да получавате 15% от цената на всеки продукт.
Това е начално ниво за всички партньори на компанията, които искат да започнат да развиват бизнес, но по различни причини все още не могат да закупят търговска система.
За да преминете към ниво 1, трябва да закупите една търговска система или пакет Професионалист в училището по трейдинг.

При закупуване на един от тези продукти получавате една година достъп до бизнес кариерната програма на компанията.

Ако закупите 2 търговски системи, веднага получавате 2 години достъп до кариерната програма на компанията.

Ако закупите 5 търговски системи, получавате 5 години достъп до кариерната програма на компанията и така нататък.

1 търговска система = още 365 дни достъп до кариерната програма на компанията.
Сега нека разгледаме второто условие:

Притежаването на 1 търговска система отключва кариерните нива от 1 до 4. Така можете да достигнете ниво 4 в рамките на 365 дни. За да продължите развитието си и да печелите повече, трябва да закупите още 2 търговски системи.

Притежаването на 3 търговски системи отключва кариерните нива от 1 до 7. Така разполагате с 3 години, за да достигнете ниво 7.`,
            `За да отключите всички 10 нива, трябва да закупите 5 търговски системи. Така активирате всички 10 кариерни нива, получавате достъп до маркетинговия план за 5 години и можете да печелите до 45% от цената на продукта от всяка лична продажба.

Търговските системи могат да се закупуват постепенно с напредването ви по нивата.

Лицензите за търговските системи са безсрочни и след закупуването им остават ваши завинаги.

За да научите как да напредвате в кариерната програма и да достигате нови нива, препоръчваме да гледате видеото на главната страница Маркетинг.`,
          ],
        },
      },
    },
    partners: {
      structureTree: 'Дърво на структурата',
      resetFilter: 'Нулирай филтъра',
      selectSortingMethod: 'Изберете начин на сортиране',
      loginOrPartnerEmail: 'Логин или имейл на партньора',
      partnerId: 'ID на партньора',
      qualification: 'Квалификация',
      personalSales: 'Лични продажби',
      applyFilter: 'Приложи филтъра',
      firstLinePartnersCount: 'Брой партньори на първа линия',
      noPartners: 'Няма партньори',
      dataNotFound: 'Няма намерени данни',
      partnerLinks: 'Партньорски връзки',
      partnerLinksHint: 'Създавайте партньорски връзки за бърз достъп.',
      addPartnerLink: 'Добавете партньорска връзка',
      editPartnerLink: 'Редактирайте партньорската връзка',
      companyName: 'Име на компанията',
      enterCompanyName: 'Въведете име на компанията',
      pasteLink: 'Поставете връзката',
      enterLink: 'Въведете връзката',
      add: 'Добави',
      edit: 'Редактирай',
      maximumCharacters: 'Максимум {{count}} символа',
      deleteLinkTitle: 'Потвърждение за изтриване на връзката',
      deleteLinkDescription: 'Сигурни ли сте, че искате да изтриете връзката?',
      yes: 'Да',
      fastStartBonus: 'Бонус за бърз старт',
      daysRemaining: 'Остават {{count}} дни',
      nextQualification: 'Следваща квалификация',
      progress: 'Напредък',
      teamSales: 'Екипни продажби',
      incomePercentage: 'Моят процент доход',
      matchingBonus: 'Мачинг бонус',
      technicalSupportUntil: 'Техническа поддръжка до:',
      technicalSupport: 'Техническа поддръжка:',
      inactive: 'Не е активна',
    },
    statistics: {
      personalRegistrations: 'Лични регистрации',
      personalSales: 'Лични продажби',
      teamRegistrations: 'Екипни регистрации',
      teamSales: 'Екипни продажби',
      salesAndRegistrationsDynamics: 'Динамика на личните и екипните продажби и регистрации.',
      showAllLines: 'Покажи всички {{count}} линии',
      lines: 'Линии',
      line: '{{count}} линия',
      noOpenLines: 'Няма отворени линии',
      week: 'Седмица',
      month: 'Месец',
      halfYear: 'Половин година',
      year: 'Година',
      period: 'Период',
    },
    calculator: {
      compoundInterest: 'Сложна лихва',
      mortgage: 'Ипотека',
      financialFreedom: 'Финансова свобода',
      travel: 'Пътувания',
      pleasantPurchases: 'Приятни покупки',
      dreamCar: 'Автомобил мечта',
      bestParent: 'Бъдете най-добрият родител',
      partnerCalculator: 'Калкулатор за партньори',
      currency: 'Валута',
      ruble: 'рубла',
      dollar: 'долар',
      euro: 'евро',
      buyTradingSystem: 'Купете търговска система',
      downloadPdf: 'Изтеглете PDF',
      downloadPng: 'Изтеглете PNG',
      detailedCalculation: 'Подробно изчисление',
      fillAllFields: 'Попълнете всички полета, за да видите подробното изчисление',
      investmentTotals: 'Резултати от инвестирането',
      totalResult: 'Общо',
      instructions: 'Инструкции',
      year: 'Година',
      month: 'Месец',
      date: 'Дата',
      capitalAtTermStart: 'Капитал в началото на периода',
      startingCapitalAtTermStart: 'Начален капитал в началото на периода',
      additionalInvestments: 'Допълнителни вложения',
      additionalInvestmentsAmount: 'Сума на допълнителните вложения',
      profit: 'Печалба',
      total: 'Общо',
      investmentAmount: 'Сума на вложенията',
      monthlyProfit: 'Месечна печалба',
      monthlyProfitCar: 'Месечна печалба',
      mortgagePayment: 'Сума на ипотечната вноска',
      deposit: 'Депозит',
      carLoanPayment: 'Вноска по автокредит',
      moneyInAccount: 'Средства по сметката',
      totalAmount: 'Обща сума',
      level: 'Ниво',
      levelNumber: 'Ниво {{count}}',
      salesAmount: 'Сума на продажбите',
      mortgageDescription: 'Доходът от търговската система ще покрива <br /> месечната ипотечна вноска.',
      monthlyMortgagePayment: 'ВЪВЕДЕТЕ СУМАТА НА МЕСЕЧНАТА ИПОТЕЧНА ВНОСКА',
      monthlyInvestmentAmount: 'ВЪВЕДЕТЕ СУМАТА, КОЯТО МОЖЕТЕ ДА ИНВЕСТИРАТЕ ВСЕКИ МЕСЕЦ',
      immediateDeposit: 'КАКВА СУМА СТЕ ГОТОВИ ДА ВНЕСЕТЕ ВЕДНАГА',
      mortgageResult:
        'Ако всеки месец внасяте сума по сметката, доходът от търговската система ще покрие месечната ипотечна вноска след:',
      monthUnit_one: '{{count}} месец',
      monthUnit_few: '{{count}} месеца',
      monthUnit_many: '{{count}} месеца',
      monthUnit_other: '{{count}} месеца',
      yearUnit_one: '{{count}} година',
      yearUnit_few: '{{count}} години',
      yearUnit_many: '{{count}} години',
      yearUnit_other: '{{count}} години',
      durationWithYears: '{{years}} и {{months}}',
      dreamCarDescription:
        'Купете автомобила на мечтите си! <br /> Доходът от търговските системи ще покрие всички разходи.',
      carPrice: 'въведете стойността на автомобила, който искате да купите',
      carPurchaseDeposit: 'За покупката трябва да внесете по сметката',
      instructionStage: 'Етап {{count}}',
      mortgageInstruction1: 'Купуваме търговска система',
      mortgageInstruction2: 'Внасяме депозит от {{amount}}',
      mortgageInstruction3: 'Натрупваме депозит от {{amount}} от месечната печалба',
      mortgageInstruction4: 'С месечна печалба от {{profit}} плащаме ипотека в размер на {{payment}}',
      mortgageInstructionTotal:
        'Като генерира печалба от {{profit}}, търговската система покрива изцяло ипотечната вноска и вече не е нужно да я плащаме от собствения си джоб',
      carInstruction1: 'Купуваме USDT за {{amount}}',
      carInstruction2: 'Купуваме необходимия брой търговски системи',
      carInstruction3: 'Внасяме {{amount}} като депозит',
      carInstruction4: 'Купуваме автомобил на кредит за една година с 20% първоначална вноска',
      carInstruction5:
        'Получаваме месечен доход от {{income}}, плащаме {{payment}} по автокредита и добавяме остатъка към баланса на търговската система',
      carInstruction6: 'Покриваме всичките 12 месечни вноски с доходността от търговската система',
      carTotal1: 'Запазихме депозита от {{deposit}} и купихме автомобил',
      carTotal2: 'Получаваме месечен доход от {{income}}',
      carTotal3: 'Можем да планираме следващата покупка или да живеем от дохода от инвестициите!',
      blockDescription1: 'Този инструмент ви помага да изчислите инвестиционна стратегия с нашите търговски системи!',
      blockDescription2:
        'Тук ще научите как да създадете пенсия, да спестите за бъдещето на децата си, да пътувате по света всяка година с пасивен доход и още много!',
      blockDescription3: 'Инструментът може да се използва както за лични цели, така и при продажби към ваши клиенти',
      fillChartFields: 'Попълнете всички полета, за да видите графиката',
      fillDiagramFields: 'Попълнете всички полета, за да видите диаграмата',
      compoundInterestTitle: 'Сложна лихва',
      compoundInterestDescription:
        'Сложната лихва е лихва, която се начислява върху първоначалната сума на вложенията, както и върху лихвата, натрупана през предишните периоди. Тя предполага реинвестиране на получения доход.',
      startingCapital: 'Начален капитал',
      investmentTerm: 'Срок на инвестицията',
      additionalMonthlyInvestments: 'Допълнителни месечни вложения',
      withdrawProfitMonthly: 'Теглете печалбата всеки месец',
      reinvestMonthly: 'Реинвестирайте всеки месец',
      monthUpper: 'МЕСЕЦ',
      yearUpper: 'ГОДИНА',
      monthlyRate: 'Месечна ставка',
      investmentResult: 'Резултат от инвестицията',
      financialFreedomTitle: 'Финансова свобода',
      financialFreedomDescription:
        'Искате да се реализирате? Започнете да живеете за себе си. <br /> 1000 $ по сметката днес — 110000$ след 10 години.',
      oneTimeInvestment: 'Еднократна инвестиция',
      accountAfterTime: 'след {{duration}} по сметката ще има',
      monthlyIncomeIs: 'месечният доход ще бъде',
      averageMonthlyReturn: 'при средна доходност 4% на месец',
      monthlyContributions: 'Месечни вноски',
      investmentTermLower: 'срок на инвестицията',
      yearsUpper: 'ГОДИНИ',
      bestParentDescription:
        'Доходът от търговските системи ще ви позволи да изпратите детето си да учи във всеки университет по света или да изпълните другите му мечти.',
      travelDescription: 'Пътувайте спокойно, докато търговските системи носят печалба. <br /> Заслужавате почивка!',
      annualTravelAmount: 'Въведете сумата, която искате да харчите за пътувания всяка година',
      requiredDeposit: 'За да получите такъв доход, трябва да внесете по сметката',
      pleasantPurchasesTitle: 'Приятни покупки',
      pleasantPurchasesDescription:
        'Купувайте желаното, без да харчите собствени средства. <br /> Благодарение на дохода от търговските системи.',
      equipmentCost: 'Въведете стойността на техниката',
      partnerCalculatorTitle: 'Калкулатор за партньори',
      partnerCalculatorDescription:
        'Калкулаторът за партньори ви помага да изчислите приблизителния доход от всеки партньор на първа линия. Посочете нивото си и тествайте различни сценарии за продажби, за да видите колко можете да печелите от всяка линия в структурата си.',
      careerLevel: 'вашето кариерно ниво',
      yourSales: 'Вашите продажби',
      salesAtLevel: 'Продажби на ниво {{level}}',
      totalSales: 'Обща сума на продажбите',
      travelAmount: 'Сума за пътувания',
      purchaseAmount: 'Сума за покупка',
      buyKeeper: 'Купуваме търговската система Keeper',
      depositAmount: 'Внасяме депозит от {{amount}}',
      addMonthly: 'Внасяме {{amount}} всеки месец',
      giveAccessToChildren: 'След {{duration}} предаваме достъпа до кабинета на децата',
      educationTotal:
        'След {{duration}}, благодарение на сложната лихва и месечните вноски от {{contribution}}, ще натрупаме {{total}} с месечен доход от {{income}}',
      buyTradingSystemInstruction: 'Купуваме търговска система',
      monthlyProfitForCompound: 'Получаваме месечна печалба и я оставяме по сметката за натрупване на сложна лихва',
      balanceAfterTwelveMonths: 'След 12 месеца по сметката ще има {{amount}}',
      vacationTotal:
        'С депозит от само {{deposit}}, след 12 месеца със сложна лихва ще натрупаме печалба от {{profit}} и ще можем да пътуваме',
      monthlyProfitForPurchase:
        'Получаваме месечна печалба и я оставяме в търговската система за натрупване на сложна лихва',
      purchaseTotal:
        'С депозит от само {{deposit}}, след 12 месеца със сложна лихва ще натрупаме печалба от {{profit}} и ще можем да купим нов iPhone.',
      retireAfter: 'Пенсионираме се след {{duration}}',
      financialFreedomTotal:
        'След {{duration}}, благодарение на сложната лихва и месечните вноски от {{contribution}}, ще натрупаме {{total}} с месечен доход от {{income}}',
      totalForYear: 'Общо за годината',
    },
    cart: {
      title: 'Количка',
      empty: 'Количката е празна',
      goToStore: 'Към магазина',
      total: 'ОБЩО:',
      pay: 'Плати',
      products: 'Продукти',
      confirmPayment: 'Потвърдете плащането',
      close: 'Затвори',
      error: 'Грешка!',
      done: 'Готово!',
      paymentSuccessful: 'Плащането е успешно',
      purchaseCompleted: 'Покупката е оформена',
      purchaseWillBeCredited: 'След потвърждаване на плащането продуктът ще бъде начислен в акаунта ви',
      cancel: 'Отказ',
      confirm: 'Потвърди',
      paymentMethod: 'Изберете начин на плащане',
      chooseCoin: 'Изберете монета',
      coin: 'Монета',
      chooseNetwork: 'Изберете мрежа',
      cryptocurrencyNetwork: 'Криптовалутна мрежа',
      noPaymentNetworks: 'В момента няма налични мрежи за плащане за тази монета.',
      pleaseWait: 'Моля, изчакайте.',
      invoiceCreated: 'Създадена е фактура за плащане',
      amountDue: 'За плащане: {{amount}}',
      paymentPageCoinAndNetwork: 'На страницата за плащане можете да изберете необходимите монета и мрежа',
      paymentConfirmedAutomatically: 'Плащането се потвърждава автоматично, обикновено до една минута след превода',
      goToPaymentPage: 'Към страницата за плащане',
      creatingInvoice: 'Създава се фактура…',
      operationFailed: 'Операцията не можа да бъде изпълнена. Опитайте отново.',
      recalculationFailed: 'Техническата поддръжка не можа да бъде преизчислена',
      invoiceCreationFailed: 'Не можа да бъде създадена фактура за плащане',
      receiptUploadFailed: 'Чекът не можа да бъде качен. Опитайте отново.',
      minimumPurchaseAmount: 'Минимална сума за покупка: {{amount}}',
      receiptUploadError: 'Чекът не можа да бъде качен',
      invalidFileType: 'Неподдържан тип файл. Разрешени: {{extensions}}',
      fileTooLarge: 'Файлът е по-голям от 10 MB.',
      uploadPaymentScreenshot: 'Качете екранна снимка на плащането',
      sendPaymentToAddress: 'Изпратете сумата на посочения адрес и натиснете „Платих“',
      network: 'Мрежа',
      wallet: 'Портфейл',
      walletCopied: 'Портфейлът е копиран',
      amount: 'Сума',
      payByQr: 'Плати с QR код',
      receiptProcessing: 'Чекът се обработва. Моля, изчакайте.',
      paid: 'Платих',
      quantity: 'Количество: {{count}}',
      technicalSupportMonths: 'Месеци техническа поддръжка: {{count}}',
      purchaseCommission: 'Комисиона за покупката:',
      paymentUnavailable: 'Плащането временно не е достъпно. Опитайте по-късно.',
      warning: 'Внимание!',
      cryptoAddressWarning: 'Този адрес е предназначен само за преводи на {{coin}} по мрежата {{network}}.',
      noSmartContractTransfers:
        'Не изпращайте към него преводи от смарт договори, {{baseCoin}} или друга криптовалута. Такива преводи няма да бъдат зачислени!',
      transferExactAmount:
        'Преведете точната сума (стойността на продуктите) в {{coin}} на посочения адрес с една транзакция.',
      amlMonitoring: 'Криптовалутните постъпления се наблюдават съгласно нашата AML програма.',
      receiptSample: 'ОБРАЗЕЦ НА ЧЕК',
      withdrawalDetails: 'Детайли за тегленето',
      withdrawalCompleted: 'Тегленето е завършено',
      account: 'Акаунт',
      fundingAccount: 'Акаунт за финансиране',
      networkType: 'Тип мрежа',
      commission: 'Комисиона',
      time: 'Време',
      walletAddress: 'Адрес на портфейла',
      transactionHash: 'Хеш на транзакцията (TXID)',
      receiptSampleAbove: 'Образецът на чека е посочен по-горе',
      receiptRequirementDate: '1. Дата и час на транзакцията',
      receiptRequirementHash: '2. HASH или TXID на транзакцията',
      receiptRequirementAmount: '3. Сума',
      receiptRequirementWallet: '4. Адрес на портфейла, към който са изпратени средствата',
      receiptAnyFormat: 'Чекът може да бъде във всякакъв формат, важно е да съдържа четирите типа данни',
      serverUpgrade: 'Надграждане',
      serverProlongation: 'Подновяване',
      numberOfMonths: 'Брой месеци',
      termToIssue: 'за какъв срок да се оформи',
      numberOfProducts: 'Брой продукти',
      dependsOnSystems: 'зависи от броя системи',
      subscriptionTerm: 'срок на абонамента',
      numberOfServers: 'Брой сървъри',
      serversToAdd: 'колко сървъра да се добавят',
      serversNoMergeTitle: 'Сървърите не се обединяват',
      serversNoMerge: 'Всеки закупен сървър се предоставя веднага и остава отделен, а заедно с него се издава лиценз за Windows. Затова не можем да обединим няколко сървъра в един: например два сървъра Standard за 6 месеца няма да станат един сървър за 12 месеца. Ако ви трябва един сървър за година, оставете в количката един сървър и изберете срок 12 месеца. По-късно закупеният сървър може да се надгради и да се поднови.',
      oneServer: 'един сървър',
      oneSubscription: 'един абонамент',
      tariffUpgrade: 'Надграждане на тарифата: {{from}} → {{to}}',
      tariffUpgradePrefix: 'Надграждане на тарифата:',
      serverTariffUpgrade: 'Надграждане на сървърна тарифа',
      serverId: 'Сървър ID {{id}}',
      durationDiscount: 'Отстъпка за срока {{percent}}% (без отстъпка — {{amount}})',
      technicalSupportRecalculation:
        'Ако имате повече от една търговска система, стойността на техническата поддръжка ще бъде преизчислена автоматично според броя им',
      quantityLabel: 'Количество',
    },
    products: {
      addedToCart: 'Продуктът е добавен успешно в количката',
      addToCart: 'Добави в количката',
      pay: 'Плати',
      sentToPartner: 'Продуктът е изпратен успешно на партньора',
      partnerEmailOrLoginError: 'Неправилен имейл или потребителско име на партньора',
      tryAgain: 'Опитай отново',
      enterPartnerEmailOrLogin: 'Въведете имейла или логина на партньора',
      sendToPartner: 'Изпрати на партньора',
      activate: 'Активирай',
      ourProducts: 'Нашите продукти',
      purchasedProducts: 'Закупени продукти',
      tradingSystems: 'Търговски системи',
      technicalSupport: 'Техническа поддръжка',
      activeUntil: 'Активна до',
      inactive: 'Не е активна',
      renewSupport: 'Поднови поддръжката',
      installationInstructions: 'Инструкции за инсталиране',
      totalQuantity: 'Общо количество: {{count}}',
      activationRequired: 'Необходимо е да активирате продукта',
      subscriptionAdded: 'Абонаментът е добавен в количката',
      subscriptionAddFailed: 'Абонаментът не можа да бъде добавен в количката',
      perMonth: '/ мес.',
      subscriptionActive: 'Активна от {{from}} до {{to}}',
      telegramLinked: 'Telegram е свързан',
      relink: 'Свържи отново',
      unlinkTelegram: 'Да се прекъсне връзката с {{username}}? Сигналите вече няма да пристигат в този Telegram.',
      unlink: 'Прекъсни връзката',
      linkTelegram: 'Свържи Telegram',
      subscriptionExpired: 'Абонаментът е изтекъл на {{date}}',
      renew: 'Поднови',
      applyForInstallation: 'Да подадете заявка за инсталиране?',
      installationInstructionsTitle: 'Инструкции за инсталиране',
      videoInstruction: 'Видео инструкция',
      open: 'Отвори',
      pdfInstruction: 'PDF инструкция',
      download: 'Изтегли',
      mentorHelp: 'Помощ от наставник',
      goTo: 'Към раздела',
      later: 'По-късно',
      yes: 'Да',
      skip: 'Пропусни',
      submitApplication: 'Подай заявка',
      activeOne: 'Активен продукт',
      activeFew: 'Активни продукта',
      activeMany: 'Активни продукти',
      archivedOne: 'Архивиран продукт',
      archivedFew: 'Архивирани продукта',
      archivedMany: 'Архивирани продукти',
      monthsOne: '{{count}} месец',
      monthsFew: '{{count}} месеца',
      monthsMany: '{{count}} месеца',
      inCartFor: 'В количката: {{period}}',
      subscriptionUnavailable: 'Абонаментът за сигнали в момента не е достъпен',
      currentTelegram: 'текущия Telegram',
      activeStatus: 'Активни',
      activeStatusWithCount: 'Активни: {{count}}',
      archivedStatus: 'В архива',
      archivedStatusWithCount: 'В архива: {{count}}',
    },
    vps: {
      active: 'Активен',
      awaitingPayment: 'Очаква плащане',
      provisioning: 'Създаване',
      expired: 'Абонаментът е изтекъл',
      blocked: 'Блокиран',
      error: 'Грешка',
      unknown: 'Неизвестно',
      deleted: 'Изтрит',
      expiredNotice:
        'Абонаментът е изтекъл. Подновете го в рамките на {{days}} дни, в противен случай сървърът и данните ще бъдат изтрити. Можете да влезете в сървъра, но вместо работния плот ще се покаже предложение за подновяване.',
      blockedNotice: 'Достъпът до сървъра е блокиран от администратор. Свържете се с поддръжката.',
      permanent: 'Безсрочно',
      gateway: 'ШЛЮЗ',
      activeServers: 'Активни сървъри',
      plan: 'План',
      issued: 'Издаден',
      paidUntil: 'Платен до',
      accessData: 'Данни за вход',
      upgrade: 'Промени тарифата',
      renew: 'Поднови',
      total: 'Общо:',
      noActiveServers: 'Нямате активни сървъри',
      tariffPlans: 'Тарифни планове',
      faq: 'FAQ и помощ',
      generalQuestions: 'Общи въпроси',
      serviceOperation: 'Как работи услугата',
      tradingTerminals: 'Търговски терминали',
      performance: 'Производителност',
      security: 'Сигурност',
      technicalSupport: 'Техническа поддръжка',
      needConsultation: 'Нуждаете се от консултация?',
      consultationText: 'Нашите специалисти ще ви помогнат да изберете оптималния сървър за вашите задачи.',
      contactUs: 'Свържете се с нас',
      popular: 'Популярен',
      server: 'Сървър',
      order: 'Поръчай',
      select: 'Изберете',
      login: 'ЛОГИН',
      password: 'ПАРОЛА',
      ipAddress: 'IP АДРЕС',
      downloadAccessFile: 'Изтеглете файла за достъп до VPS',
      accessHint:
        'Използвайте удобната функция за бърз достъп до VPS. Натиснете бутона по-горе, стартирайте изтегления файл и въведете паролата за VPS',
      serverRenewal: 'Подновяване на сървъра',
      tariff: 'ТАРИФА',
      amountDue: 'За плащане',
      renewVps: 'Поднови VPS',
      serverUpgrade: 'Надграждане на сървъра',
      loadingTariffs: 'Зареждане на наличните тарифи…',
      unavailableUpgrades: 'Наличните надграждания не можаха да бъдат заредени. Опитайте по-късно.',
      maximumTariff: 'Сървърът вече е на максимална тарифа.',
      surcharge: 'Доплащане',
      selectTariff: 'Изберете тарифа',
      surchargeHint: 'Доплащането е изчислено за оставащите {{days}} дни от платения период',
      upgradeVps: 'Промени тарифата',
      renewalRequiredHint: 'Минималната сума за покупка е {{amount}} $, а доплащането за надграждането не е достатъчно. За да направите поръчка, подновете сървъра поне за {{period}}',
      renewalTotal: 'Общо: {{surcharge}} $ надграждане + {{renewal}} $ подновяване',
      renewalMinHint: 'Минималната сума за плащане е {{amount}} $, затова е избран минималният срок на подновяване: {{period}}. Срокът може да се увеличи.',
      productAddedToCart: 'Продуктът е добавен успешно в количката',
      renewalAddedToCart: 'Подновяването на сървъра е добавено успешно в количката',
      upgradeAddedToCart: 'Надграждането на сървъра е добавено успешно в количката',
      terminalOne: 'терминал',
      terminalFew: 'терминала',
      terminalMany: 'терминала',
      tariffTooltips: {
        standard:
          'Базова тарифа за един търговски терминал MT4 или MT5. Подходяща е за начинаещи и инвеститори с една търговска система и за стабилна ежедневна работа.',
        pro: 'Тарифа за активни потребители, работещи едновременно с няколко терминала MT4 и MT5. Поддържа до 3 терминала и удобно управление на няколко търговски системи на един сървър.',
        business:
          'Оптимално решение за опитни трейдъри и инвеститори с няколко стратегии. Поддържа до 5 терминала MT4 и MT5 за разширено портфолио от търговски системи.',
        enterprise:
          'Професионална тарифа за високо натоварване. Поддържа до 8 терминала MT4 и MT5 и осигурява максимална гъвкавост при работа с различни стратегии и инвестиционни направления.',
        ultimate:
          'Максимална тарифа за мащабна работа с търговски системи. Поддържа до 15 терминала MT4 и MT5 за професионалисти, управляващи много стратегии и инвестиционни проекти.',
      },
    },
    vpsFaq: {
      s1q1: {
        title: 'Какво е FT Server?',
        content:
          'FT Server е отдалечен Windows сървър за денонощна работа на търговските терминали MetaTrader 4 и MetaTrader 5 независимо от вашия компютър.',
      },
      s1q2: {
        title: 'За какво служи FT Server?',
        content:
          'FT Server осигурява непрекъсната работа на търговските терминали дори когато компютърът е изключен или няма интернет или електричество.',
      },
      s1q3: {
        title: 'За кого е подходящ FT Server?',
        content: 'За трейдъри, инвеститори и собственици на търговски роботи (експертни съветници).',
      },
      s1q4: {
        title: 'Трябва ли компютърът да остане включен?',
        content:
          'Не. След като стартирате терминалите на FT Server, можете да изключите компютъра или да затворите прозореца за връзка. Терминалите и търговските роботи ще продължат да работят денонощно на сървъра.',
      },
      s1q5: {
        title: 'Ще работи ли FT Server без домашен интернет и електричество?',
        content:
          'Да. FT Server работи в професионален център за данни и не зависи от вашия компютър, домашен интернет или електрозахранване.',
      },
      s1q6: {
        title: 'Необходими ли са специални технически знания?',
        content:
          'Не. FT Server е напълно готов за работа, а при необходимост специалистите ще помогнат със свързването.',
      },
      s2q1: {
        title: 'Какво ще получа след плащането?',
        item1: 'готов файл за връзка (.rdp) с адреса на сървъра',
        item2: 'логин',
        item3: 'парола',
        item4: 'инструкции за свързване',
      },
      s2q2: {
        title: 'Колко време отнема активирането?',
        content: 'Обикновено сървърът е готов за работа до няколко минути след плащането.',
      },
      s2q3: {
        title: 'С каква операционна система работи сървърът?',
        content: 'С Windows Server 2025 — сървърът е готов за използване веднага след свързване.',
      },
      s2q4: {
        title: 'Мога ли да се свържа от Mac?',
        content: 'Да — чрез Windows App (предишното Microsoft Remote Desktop).',
      },
      s2q5: {
        title: 'Мога ли да се свържа от телефон?',
        content: 'Да, чрез RDP клиент: Windows App за iPhone/iPad или Remote Desktop за Android.',
      },
      s2q6: {
        title: 'Мога ли да се свържа от няколко устройства?',
        content:
          'Да — от настолен компютър, лаптоп, таблет или смартфон. Свързвате се към един и същ работен плот от всяко устройство; терминалите не се дублират и продължават да работят.',
      },
      s3q1: { title: 'Кои платформи се поддържат?', item1: 'MetaTrader 4 (MT4)', item2: 'MetaTrader 5 (MT5)' },
      s3q2: {
        title: 'Трябва ли да инсталирам MetaTrader?',
        content: 'Не. Терминалите вече са инсталирани и готови за работа.',
      },
      s3q3: {
        title: 'Мога ли да стартирам няколко терминала?',
        content: 'Да. Броят на едновременно работещите терминали зависи от избраната тарифа.',
      },
      s3q4: {
        title: 'Коя тарифа да избера?',
        item1: 'Standard за 1 терминал — за работа с един MT4 или MT5 терминал',
        item2: 'Pro за до 3 терминала — за едновременна работа с няколко търговски системи',
        item3: 'Business за до 5 терминала — за няколко стратегии',
        item4: 'Enterprise за до 8 терминала — за професионална работа с високо натоварване',
        item5: 'Ultimate за до 15 терминала — за мащабна работа с голям брой терминали',
      },
      s4q1: {
        title: 'Защо FT Server е по-добър от домашен компютър?',
        item1: 'работи 24/7',
        item2: 'висока стабилност',
        item3: 'минимално забавяне',
        item4: 'бърза интернет връзка',
      },
      s4q2: {
        title: 'Какво е ниско забавяне (Low Latency)?',
        content:
          'Това е минималното време за предаване на данни до търговския сървър, което помага за по-бързо изпълнение на търговските операции.',
      },
      s4q3: {
        title: 'Къде се намират сървърите?',
        content: 'Сървърите се намират в професионални центрове за данни с надеждна инфраструктура.',
      },
      s5q1: {
        title: 'Колко сигурен е FT Server?',
        content: 'Всеки потребител получава отделен акаунт с индивидуални данни за вход. Връзката е криптирана.',
      },
      s5q2: {
        title: 'Може ли някой друг да получи достъп до моя сървър?',
        content:
          'Не. Вашият акаунт, файлове, настройки и търговски сесии са напълно изолирани и другите потребители нямат достъп до тях.',
      },
      s5q3: {
        title: 'Ще се запазят ли данните ми след рестартиране?',
        content:
          'Да. Терминалите, експертните съветници, индикаторите, настройките и файловете се запазват. След планиран рестарт на сървъра търговските терминали трябва да бъдат стартирани отново; уведомяваме предварително за такава поддръжка.',
      },
      s6q1: {
        title: 'Помагате ли със свързването?',
        content: 'Да. Специалистите ще ви помогнат да се свържете със сървъра и ще отговорят на въпросите ви.',
      },
      s6q2: {
        title: 'Предлагате ли помощ при настройването?',
        content: 'Да. При необходимост специалистите ще помогнат с първоначалната настройка и започването на работа.',
      },
    },
    auth: {
      signInTitle: 'Вход',
      resetPasswordTitle: 'Възстановяване на парола',
      signIn: 'Вход',
      signInToAccount: 'Влезте в акаунта',
      register: 'Регистрация',
      registerAction: 'Регистрирайте се',
      haveAccount: 'Вече имате акаунт?',
      noAccount: 'Нямате акаунт?',
      continue: 'Продължи',
      confirm: 'Потвърди',
      back: 'Назад',
      returnToLogin: 'Обратно към входа?',
      email: 'Имейл',
      login: 'Логин',
      password: 'Парола',
      repeatPassword: 'Повторете паролата',
      partnerCode: 'Код на партньора',
      emailConfirmationCode: 'Код за потвърждение по имейл',
      confirmationCode: 'Код за потвърждение',
      confirmationMethod: 'Начин на потвърждение',
      confirmByEmail: 'По имейл',
      confirmByGoogle: 'Чрез Google Authenticator',
      clearData: 'Изчистете данните',
      forgotPassword: 'Забравили сте паролата?',
      passwordSent: 'Нова парола е изпратена на {{email}}',
      waitForCode: 'Изчакайте кода за потвърждение: {{count}} сек.',
      signInConsent: 'С влизането приемате условията в нашите документи и потвърждавате, че сте навършили 18 години.',
      registrationConsent:
        'С регистрацията приемате условията в нашите документи и потвърждавате, че сте навършили 18 години.',
      timeWarning: 'Часът на устройството не е синхронизиран. Това може да повлияе на работата на Google 2FA.',
      documents: {
        publicOffer: 'Публична оферта',
        privacyPolicy: 'Политика за поверителност',
        riskNotice: 'Предупреждение за риска',
        systemGuide: 'Ръководство за използване на софтуера',
      },
      footer: {
        legalAddress: 'Юридически адрес:',
        registrationNumber:
          'Quijano Chambers, P.O. Box 3159, Road Town, Tortola, British Virgin Islands, държавен регистрационен номер 2156676',
        riskTitle: 'Предупреждение за риска:',
        riskText:
          'Търговията с продукти с ливъридж, като CFD, носи високо ниво на риск. Не търгувайте и не инвестирайте, ако не разбирате напълно риска от загуба. Винаги отчитайте нивото си на опит, тъй като неправилното инвестиране може да доведе до загуба на средства. Ако свързаните рискове не са ви ясни, потърсете независим съвет от външен специалист.',
      },
      googleAuthenticator: {
        downloadTitle: 'Изтеглете Google Authenticator',
        downloadDescription:
          'Изтеглете и инсталирайте приложението Authenticator на телефона си, след което свържете акаунта си.',
        downloadIos: 'Изтеглете Google Authenticator (iOS)',
        downloadAndroid: 'Изтеглете Google Authenticator (Android)',
        connectTitle: 'Свържете Google Authenticator',
        connectInstructionTitle: 'Свържете Google Authenticator',
        openAndStart: 'Отворете приложението и натиснете „Започнете“',
        chooseAuthenticationMethod: 'Изберете начин за удостоверяване',
        scanQrCode: 'Сканирайте QR кода',
        enterKey: 'Въведете ключа',
        keyCopied: 'Ключът е копиран',
        done: 'Готово',
        disconnectTitle: 'Прекъснете връзката с Google Authenticator',
        disconnectConfirmation: 'Сигурни ли сте, че искате да прекъснете връзката с Google Authenticator?',
        disconnect: 'Прекъснете връзката',
        cancel: 'Отказ',
      },
      errors: {
        enterEmail: 'Въведете имейл',
        enterLogin: 'Въведете логин',
        enterPassword: 'Въведете парола',
        enterPartnerCode: 'Въведете реферален код',
        enterConfirmationCode: 'Въведете кода за потвърждение',
        enterEmailConfirmationCode: 'Въведете кода за потвърждение по имейл',
        repeatPassword: 'Повторете паролата',
        invalidEmail: 'Невалиден имейл',
        emailLatinOnly: 'Имейлът съдържа латински символи',
        loginLatinOnly: 'Логинът трябва да съдържа само латински символи',
        loginLength: 'Логинът трябва да е с дължина от {{min}} до 36 символа',
        loginContainsAt: 'Логинът съдържа @',
        loginContainsSpaces: 'Логинът съдържа интервали',
        loginCharacters: 'Логинът може да съдържа само латински букви, цифри и специални символи .-_!',
        loginCharactersNoUppercase:
          'Логинът може да съдържа само латински букви, цифри и специални символи .-_ и не трябва да съдържа главни букви',
        loginNoUppercase: 'Логинът не трябва да съдържа главни букви',
        passwordCharacters: 'Паролата може да съдържа само латински букви, цифри и !@#$%^&*()-+',
        registrationPasswordCharacters:
          'Паролата може да съдържа само латински букви, цифри и следните специални символи: % & ! ? # $ * + , . - + : @ _',
        passwordComplexity:
          'Паролата трябва да съдържа поне 2 от 4: малки букви, главни букви, цифри, специални символи',
        codeLength: 'Кодът трябва да съдържа от 6 до 9 символа',
        invalidCode: 'Невалиден код за потвърждение',
        invalidCredentials: 'Невалиден логин или парола',
        sendCodeError: 'Неуспешно изпращане на имейл',
        selectMethod: 'Изберете начин на потвърждение',
        emailTaken: 'Логинът или имейлът вече се използват',
        weakPassword: 'Паролата е твърде лесна',
        invalidReferralCode: 'Невалиден реферален код',
        passwordsMismatch: 'Паролите не съвпадат',
        referralLowercase: 'Рефералният код трябва да съдържа поне една малка буква',
        referralUppercase: 'Рефералният код трябва да съдържа поне една главна буква',
        referralDigit: 'Рефералният код трябва да съдържа поне една цифра',
        referralLength: 'Кодът трябва да е с дължина {{length}} символа',
      },
    },
    promo: {
      windowTitle: 'ПРОМОЦИИ',
      learnMore: 'Научете повече',
      materials: {
        title: 'Промоционални материали',
        presentations: 'презентации',
        video: 'видео',
        photos: 'снимки',
        reviews: 'отзиви',
        run: 'промоционални кампании',
      },
      summer: {
        imageAlt: 'Удължаваме голямата томбола до 1 октомври',
        intro: 'Приятели, удължихме за вас лятната томбола с ценни награди от компанията „FT Holding Trade“!',
        prizePlaces: '30 наградни места —',
        prizePlacesDescription: 'за топ техника и търговски системи',
        period: 'Период на провеждане: 01.06.2026 — 01.10.2026',
        dontMissChance: 'Не изпускайте шанса си!',
        conditionsTitle: 'УСЛОВИЯ ЗА УЧАСТИЕ:',
        participation: {
          lineOne: 'За участие в томболата за',
          lineTwo: 'награди е необходимо:',
          description:
            'Да направите 2 покупки или 2 продажби на каквито и да е търговски системи през периода на томболата',
          buyTicket: '2 покупки = 1 билет',
          sellTicket: '2 продажби = 1 билет',
          story: 'И да споделите стори в своя Telegram акаунт, като добавите отдолу връзка към този канал.',
          whatsapp:
            'Нямате Telegram Premium? Можете да публикувате стори в WhatsApp и да добавите връзка към този канал',
        },
        prizeListTitle: 'Списък с награди:',
        prizeList: {
          1: '— MacBook Neo (5 бр.)',
          2: '— iPhone 17 Pro Max (5 бр.)',
          3: '— таблет Samsung (5 бр.)',
          4: '— Apple Watch SE (5 бр.)',
          5: '— AirPods Pro (5 бр.)',
          6: '— Търговски системи на стойност 650$ (5 бр.)',
        },
        applicationTitle: 'За да подадете заявка за участие, е необходимо:',
        codeWord: 'да изпратите кодовата дума „ЛЕТО“ до отдела за промоции, за да получите билет за участие',
        collectionStart: 'Начало на събирането на заявки: 1 юни 2026 г.',
        sendApplications: 'Изпращайте заявленията тук:',
        rulesTitle: 'ПРАВИЛА НА ТОМБОЛАТА:',
        collection: 'Събиране на заявки:',
        collectionUntil: 'включително до 00:00 ч. МСК',
        results: 'Обявяване на резултатите:',
        resultsDate: '05.10.2026 г. в 18:00 ч. МСК',
        zoomLink: 'връзката за Zoom ще бъде изпратена в канала за поддръжка',
        finalTitle: 'Времето ще мине неусетно. Станете част от най-голямата общност на трейдъри този сезон',
        rules: {
          1: {
            before: 'За да получите билет за участие, трябва да сте абонирани за',
            link: 'основния канал',
            after: 'на компанията до края на томболата.',
          },
          2: 'Можете да спечелите само една награда от първата категория. Ако станете победител два пъти, втората награда ще бъде изтеглена отново.',
          3: 'Билетите за продажба и покупка НЕ СЕ ОБЕДИНЯВАТ, а се броят отделно. Трябва да направите 2 покупки ИЛИ 2 продажби, за да получите 1 билет за участие.',
          4: 'Наградите ще бъдат изтеглени онлайн чрез рандомайзер.',
          5: 'Не можете да прехвърляте или подарявате билетите си на други участници.',
          6: 'Не можете да променяте своето потребителско име (ник) в Telegram от началото до края на томболата.',
          7: 'Присъствието на живо от личния ви акаунт е ЗАДЪЛЖИТЕЛНО. Никой не може да присъства вместо вас.',
          8: 'При откриване на множество акаунти, повторни регистрации или други манипулации с правилата организаторите си запазват правото да дисквалифицират напълно участника и да откажат предоставянето на награди.',
          9: 'Всички спечелени награди — както джаджи, така и търговски системи — се предоставят само в първоначалния им вид; замяна на подаръците с паричната им стойност в рамките на тази промоция не е предвидена.',
        },
      },
      server: {
        modalTitle: 'ТОМБОЛА ПО СЛУЧАЙ ИЗЛИЗАНЕТО НА FT SERVER!',
        modalText:
          'Организираме нова промоция за първите потребители на новия ни продукт — FT Server. Абонирайте се за сървър и участвайте в томболата за страхотни награди!',
        collectionDates: 'Период на участие: 01.09.2026 — 01.12.2026',
        imageAlt: 'Томбола по случай излизането на FT Server',
        intro: 'Приятели, решихме да организираме нова промоция за първите потребители на новия ни продукт — FT Server',
        introAction: 'Абонирайте се за сървър и участвайте в томболата за страхотни награди!',
        infrastructure: {
          lineOne: 'Нова инфраструктура',
          lineTwo: 'Нови възможности',
          lineThree: 'Големи награди',
          descriptionOne: 'FT Server е създаден за стабилна работа на търговските терминали 24/7',
          descriptionTwo: 'По случай старта раздаваме три технологични награди на първите потребители',
        },
        collection: 'Събиране на заявки',
        results: 'Обявяване на резултатите',
        resultsDate: '04.12.2026 г. в 17:00 ч. МСК',
        dontMissChance: 'Не изпускайте шанса си!',
        prizesTitle: 'КАКВО Е ЗАЛОЖЕНО?',
        conditionsTitle: 'УСЛОВИЯ ЗА УЧАСТИЕ',
        conditionsLead: 'Изберете план и срок на абонамента, които отговарят на условията на томболата:',
        startPlans: 'Standard 1 или Pro 3',
        advancedPlans: 'Business 5 или Enterprise 8 или Ultimate 15',
        twoYears: '2 ГОДИНИ',
        oneYear: '1 ГОДИНА',
        eligiblePayment: 'Всяко отговарящо на условията плащане дава 1 право на участие',
        howToParticipate: 'КАК ДА УЧАСТВАТЕ',
        rulesTitle: 'ПРАВИЛА НА ТОМБОЛАТА',
        finalTitle: 'Свържете FT Server и вземете своите подаръци',
        finalLineOne: 'Два месеца',
        finalLineTwo: 'ще минат неусетно!',
        participate: 'Участвайте в томболата',
        chooseFtServer: 'Изберете FT Server',
        prizes: {
          first: {
            place: '1-ВО МЯСТО',
            text: 'Станете собственик на нов iPhone, за да следите търговските си системи с максимална скорост',
          },
          second: {
            place: '2-РО МЯСТО',
            title: '50% отстъпка за търговска система FT',
            text: 'Достъпно само при покупка на системи на стойност $650. Вашият път към автоматизираната търговия на половин цена',
          },
          third: {
            place: '3-ТО МЯСТО',
            title: 'FT Server',
            subtitle: 'за 15 терминала',
            text: 'План Ultimate за 12 месеца. Максимална производителност и непрекъсната работа на всички терминали',
          },
        },
        steps: {
          first: {
            title: 'Купете абонамент',
            lineOne: 'Standard 1 / Pro 3 — за 2 години.',
            lineTwo: 'Business 5 / Enterprise 8 / Ultimate 15 — за 1 година.',
          },
          second: { title: 'Изпратете кодовата дума', text: 'FT SERVER на @gtgcontrol' },
          third: {
            title: 'Получете билет за участие',
            text: 'Получете официалния си билет и изчакайте финала на томболата.',
          },
        },
        rules: {
          left: {
            1: 'В промоцията участват абонаменти за FT Server, платени в периода от 1 септември до 1 декември 2026 г.',
            2: 'За Standard 1 и Pro 3 условието за участие е покупка на сървър за срок от поне 2 години',
            3: 'За Business 5, Enterprise 8 и Ultimate 15 условието за участие е покупка на сървър за срок от поне 1 година',
            4: 'Всяко плащане, което отговаря на условията, дава 1 право на участие в томболата',
            5: 'Сумирането на отделни плащания или частично плащане не се вземат предвид',
            6: 'За участник в томболата се счита потребител, получил официален билет след изпълнение на всички условия на промоцията',
            7: 'Томболата ще се проведе на живо на 4 декември в 17:00 МСК',
          },
          right: {
            1: 'Победителите се определят на случаен принцип измежду участниците, получили билет за участие.',
            2: 'За да получи награда, участникът трябва да присъства на живото излъчване по време на томболата',
            3: 'При възстановяване на средства участието в промоцията се анулира автоматично',
            4: 'Паричната равностойност на наградите не се изплаща',
            5: 'Организаторът има право да замени наградата с аналогична по стойност, ако заявеният модел не е наличен при доставчика',
            6: 'Организаторът си запазва правото да промени сроковете, условията и реда на промоцията при форсмажорни обстоятелства',
          },
        },
      },
    },
    support: {
      title: 'Поддръжка',
      searchPlaceholder: 'Въведете въпроса си',
      nothingFound: 'Няма намерени резултати',
      popularTopics: 'Популярни теми',
      chatWithSupport: 'Чат с поддръжката',
      askQuestion: 'Задайте въпрос',
      followUs: 'Последвайте ни!',
      newsDescription: 'И бъдете в крак с всички новини',
      back: 'Назад',
      nextArticle: 'Следваща статия',
      relatedArticles: 'Още по темата',
      article: {
        apiKeysQuestion: 'Откъде да вземете API ключове',
        apiKeysStepOne:
          'Първо трябва да се регистрирате на тази борса. След това отворете настройките за API, както е показано на изображението по-долу.',
        apiKeysStepTwo: 'Въведете име за своя API ключ и натиснете „API created“.',
        apiKeysStepThree:
          'В изскачащия прозорец натиснете „Get code“. Той ще бъде изпратен на имейл адреса, с който е регистриран вашият Binance акаунт.',
        apiKeysStepFour:
          'Въведете го в полето вляво и въведете кода си за двуфакторна автентикация. За сигурност препоръчваме да използвате двуфакторна автентикация. След това натиснете „Send“. Ще се покажат вашите API Key и Secret key. Запазете тези данни: изгубен Secret key не може да бъде възстановен.',
        huobiQuestion: 'Създаване на API ключ в Huobi',
        huobiStep:
          'Отворете сайта на Huobi и влезте в акаунта си. След това натиснете иконата на профила в горния десен ъгъл и изберете „API Management“.',
        binanceQuestion: 'Как да създадете API ключ в Binance',
      },
    },
    speedTest: {
      title: 'СКОРОСТ НА ИНТЕРНЕТА',
      download: 'ИЗТЕГЛЯНЕ',
      upload: 'КАЧВАНЕ',
      retry: 'ПОВТОРИ',
      ratings: { 1: 'МНОГО БАВНО', 2: 'БАВНО', 3: 'НОРМАЛНО', 4: 'ДОБРО', 5: 'ОТЛИЧНО' },
    },
    academy: { title: 'Академия', open: 'Отвори' },
    currencyRates: {
      loadingError: 'Грешка при зареждането на котировките',
      reload: 'Презареди',
      loading: 'Зареждане...',
    },
    breadcrumbs: { partner: 'Партньор', marketing: 'маркетинг' },
    news: { title: 'Новини', important: 'Важни новини' },
    p2p: {
      identityVerification: 'Потвърждаване на самоличността',
      higherInStructure: 'По-нагоре в структурата',
      lowerInStructure: 'По-надолу в структурата',
      joined: 'Присъединил се',
      country: 'Държава',
      email: 'Имейл',
    },
    shared: {
      referralLink: 'Реферална връзка',
      decrease: 'Намали',
      increase: 'Увеличи',
      linkCopied: 'Връзката е копирана',
      no: 'Не',
      connectGoogleAuthenticator: 'Свържете Google Authenticator',
      valueOfMax: '{{value}} от {{max}}',
    },
    apiErrors: {
      generic: 'Действието не можа да бъде изпълнено. Опитайте отново.',
      server: 'Вътрешна грешка на сървъра. Опитайте по-късно.',
      unavailable: 'Услугата временно не е достъпна. Опитайте по-късно.',
      network: 'Няма връзка със сървъра. Проверете интернет връзката си.',
      secure: 'Неуспешно установяване на защитена връзка. Обновете страницата.',
      weak: 'Слаба връзка. Опитайте отново.',
      tooLarge: 'Обемът на данните е твърде голям.',
      tooMany: 'Твърде много заявки. Изчакайте една минута.',
      banned: 'Достъпът е временно ограничен поради твърде много заявки. Опитайте отново след {{seconds}} сек.',
      newVersion: 'Налична е нова версия на личния кабинет. Страницата ще се обнови.',
      loginRequired: 'Влезте в акаунта си.',
      sessionEnded: 'Сесията приключи. Влезте отново.',
      sessionExpired: 'Сесията е изтекла. Влезте отново.',
      accessCheckFailed:
        'Неуспешно потвърждаване на достъпа до акаунта. Влезте отново. Ако не можете да влезете, свържете се с поддръжката.',
      validation: 'Проверете въведените данни.',
      loginExpired: 'Времето за вход изтече. Въведете отново логина и паролата.',
      registry: {
        account: {
          progressUnavailable: 'Данните за напредъка временно не са достъпни.',
          statisticsUnavailable: 'Статистиката временно не е достъпна.',
        },
        common: {
          wrongConfirmationCode:
            'Невалиден код за потвърждение. Въведете отново логина и паролата и поискайте нов код.',
          actionRefresh: 'Действието не можа да бъде изпълнено. Обновете страницата.',
        },
        validation: {
          required: 'Задължително поле',
          invalidFormat: 'Невалидни символи или формат',
          tooShort: 'Стойността е твърде кратка',
          tooLong: 'Стойността е твърде дълга',
          invalid: 'Невалидна стойност',
          integer: 'Въведете цяло число',
          number: 'Въведете число',
          belowMinimum: 'Стойността е под допустимия минимум',
          aboveMaximum: 'Стойността е над допустимия максимум',
          selectFromList: 'Изберете стойност от списъка',
        },
        auth: {
          enterCredentials: 'Въведете логин и парола',
          securityUnavailable:
            'Настройките за сигурност на акаунта не могат да бъдат заредени. Свържете се с поддръжката.',
          startFailed: 'Входът не може да бъде стартиран. Опитайте отново.',
          continueFailed: 'Входът не може да продължи. Опитайте отново или се свържете с поддръжката.',
          sendCodeFailed: 'Кодът не може да бъде изпратен. Опитайте отново.',
          sendSmsFailed: 'SMS с кода не може да бъде изпратен. Опитайте отново.',
          completeFailed: 'Входът не може да бъде завършен. Опитайте отново.',
          signInFailed: 'Входът е неуспешен. Свържете се с поддръжката.',
          codeResent:
            'Кодът е изпратен отново. За вход ще се използва паролата, въведена при първия опит за регистрация.',
          emailOrLoginTaken: 'Имейлът или логинът вече се използват',
          weakPassword:
            'Паролата е твърде слаба. Използвайте поне два вида символи: цифри, главни и малки букви или специални символи.',
          referralNotFound: 'Рефералният код не е намерен',
          registrationFailed: 'Регистрацията е неуспешна. Опитайте по-късно.',
          invalidEmail: 'Невалиден имейл',
          invalidEmailOrCode: 'Невалиден имейл или код. Ако акаунтът вече е потвърден, влезте.',
          confirmEmailFailed: 'Имейл адресът не може да бъде потвърден. Опитайте по-късно.',
          emailConfirmed: 'Имейл адресът е потвърден. Влезте в акаунта си.',
          expiredEmailCode: 'Невалиден имейл или код. Ако са минали повече от 5 минути, поискайте нов код.',
          sendConfirmationFailed: 'Кодът за потвърждение не може да бъде изпратен. Опитайте по-късно.',
          methodUnavailable: 'Този метод за потвърждение не е свързан. Изберете друг.',
          invalidOrExpiredCode: 'Невалиден или изтекъл код',
          accountUnconfirmed: 'Акаунтът не е потвърден',
          userNotFound: 'Потребителят не е намерен',
          confirmEmailToSignIn: 'Потвърдете имейл адреса си, за да влезете',
        },
        cart: {
          empty: 'Количката е празна.',
          insufficientFunds: 'Недостатъчна наличност. Добавете средства, за да платите поръчката.',
          partialActivation:
            'Плащането е успешно, но част от продуктите не са активирани. Активирайте ги в раздела с купени продукти или се свържете с поддръжката.',
          manualDisabled: 'Плащането чрез превод към портфейл е изключено.',
          paymentAssetUnavailable: 'Избраната мрежа или монета не е достъпна. Изберете друга.',
          coinsbuyDisabled: 'Плащанията чрез Coinsbuy са изключени.',
          coinsbuyUnavailable: 'Плащанията чрез Coinsbuy временно не са достъпни. Изберете друг метод.',
          coinsbuyCreateFailed: 'Плащането чрез Coinsbuy не може да бъде създадено. Опитайте по-късно.',
          paymentCreateFailed: 'Плащането не може да бъде създадено. Опитайте по-късно или изберете друг метод.',
          invoiceUnavailable: 'Фактурата не е намерена или вече е обработена.',
          emptyFile: 'Файлът е празен. Изберете друг файл.',
          fileTooLarge: 'Файлът е твърде голям. Опитайте да го качите като файл.',
          tariffUnavailable: 'Тарифата не е достъпна. Обновете списъка с тарифи.',
          currentTariffUnknown: 'Текущата тарифа на сървъра не може да бъде определена. Свържете се с поддръжката.',
          upgradeInCart: 'Надграждането за този сървър вече е в количката. Премахнете го, за да изберете друга тарифа.',
          productUnavailable: 'Продуктът вече не е достъпен.',
          addFailed: 'Продуктът не може да бъде добавен в количката. Опитайте отново.',
          itemRemoved: 'Продуктът вече е премахнат от количката.',
          duplicateRows: 'Продуктът има няколко реда в количката. Обновете количката и изберете необходимия ред.',
          quantityFailed: 'Количеството не може да бъде променено. Опитайте отново.',
          subscriptionQuantity:
            'Абонаментът се купува като един продукт. За да промените срока, премахнете го и го добавете отново.',
          renewalQuantity: 'При подновяване променяйте срока в месеци, а не количеството.',
          minSignalsMonths: 'Минималният срок на абонамента за сигнали е 3 месеца.',
          renewalTermInvalid: 'Този срок на подновяване не е разрешен заедно с промяна на тарифата.',
          minAmount: 'Минималната сума за покупка е {{amount}} $.',
        },
        confirmation: {
          settingsUnavailable: 'Настройките за сигурност не могат да бъдат заредени. Обновете страницата.',
          addPhoneFirst: 'Първо добавете телефонен номер в профила си.',
          phoneCodeFailed:
            'Кодът не може да бъде изпратен. Защитата по телефон може вече да е включена — обновете страницата.',
          requestNewCode: 'Невалиден или изтекъл код. Поискайте нов.',
          disablePhoneFailed: 'Защитата по телефон не може да бъде изключена. Обновете страницата.',
          connectGoogleFailed:
            'Google Authenticator не може да бъде свързан. Възможно е вече да е свързан — обновете страницата.',
          googleCodeInvalid:
            'Невалиден код. Уверете се, че часът на телефона се задава автоматично, и въведете нов код.',
          disableGoogleFailed: 'Google Authenticator не може да бъде изключен. Обновете страницата.',
          googleNotConnected: 'Google Authenticator не е свързан.',
          invalidCode: 'Невалиден код',
          telegramOtherAccount: 'Друг Telegram ID вече е свързан с вашия акаунт.',
          telegramConnected: 'Telegram вече е свързан.',
          telegramIdUsed: 'Този Telegram ID вече е регистриран.',
          telegramConnectFailed: 'Telegram не може да бъде свързан. Опитайте по-късно.',
          telegramBonusFailed: 'Telegram е свързан, но бонусът не е начислен. Свържете се с поддръжката.',
          telegramAuthFailed: 'Неуспешна авторизация чрез Telegram. Опитайте отново.',
          telegramAuthCancelled: 'Авторизацията чрез Telegram е отменена.',
        },
        content: {
          eventNotFound: 'Събитието не е намерено.',
          newsNotFound: 'Новината не е намерена.',
          supportSectionNotFound: 'Разделът не е намерен.',
          supportArticleNotFound: 'Статията не е намерена.',
        },
        finance: {
          historyUnavailable: 'Историята на операциите не може да бъде заредена.',
          cancelFailed: 'Операцията не може да бъде отменена. Обновете историята: статусът може да се е променил.',
          balanceUnavailable: 'Балансът не може да бъде зареден.',
          walletAndNetwork: 'Посочете портфейл и мрежа',
          minimumAmount: 'Сумата трябва да е цяло число не по-малко от 30',
          withdrawalFailed: 'Заявката за теглене не може да бъде създадена. Опитайте по-късно.',
          withdrawalUnavailable:
            'Заявката не може да бъде създадена: недостатъчна наличност или избраната мрежа не е достъпна.',
        },
        partner: {
          structureUnavailable: 'Структурата не може да бъде заредена.',
          referralUnavailable: 'Рефералната връзка не е достъпна.',
          academyLoadFailed: 'Данните за Академията не могат да бъдат заредени.',
          academyUnavailable: 'Данните за Академията не са достъпни.',
          profileUnavailable: 'Профилът на партньора не е достъпен.',
          purchasesForbidden: 'Нямате достъп до покупките на този партньор.',
          materialNotFound: 'Материалът не е намерен.',
        },
        products: {
          activationFailed: 'Продуктът не може да бъде активиран. Опитайте отново или се свържете с поддръжката.',
          transferFailed: 'Продуктът не може да бъде прехвърлен. Проверете дали партньорът е във вашата структура.',
        },
        profile: {
          dataUnavailable: 'Данните не могат да бъдат заредени. Обновете страницата.',
          deleteFailed: 'Акаунтът не може да бъде изтрит. Опитайте по-късно.',
          alreadyDeleted: 'Акаунтът вече е изтрит.',
          passwordSessionExpired: 'Паролата не може да бъде променена. Влезте отново и повторете.',
          passwordInvalid:
            'Текущата парола е неправилна или новата парола е твърде слаба или съдържа неподдържани символи (? , . : _).',
          passwordFailed: 'Паролата не може да бъде променена. Опитайте по-късно.',
          profileUnavailable: 'Профилът не може да бъде зареден. Обновете страницата.',
          phoneProtected:
            'Промените са запазени. Телефонният номер не може да се промени, докато защитата по телефон е включена.',
          saveFailed: 'Промените не могат да бъдат запазени. Опитайте отново.',
          photosTooLarge: 'Снимките са твърде големи. Намалете размера им и опитайте отново.',
          documentsFailed:
            'Документите не могат да бъдат изпратени. Възможно е заявката вече да се проверява или верификацията да е завършена.',
          verificationUnavailable: 'Статусът на верификацията не може да бъде получен.',
          securityUnavailable: 'Настройките за сигурност не могат да бъдат получени.',
          linksUnavailable: 'Връзките не могат да бъдат заредени.',
          addLinkFailed: 'Връзката не може да бъде добавена.',
          linkNotSaved: 'Връзката не е намерена или не е запазена. Списъкът е обновен.',
        },
        servers: {
          provisioningFailed: 'Грешка при предоставянето на сървъра. Свържете се с поддръжката.',
          tariffDiscontinued: 'Тази тарифа вече не се предлага. Свържете се с поддръжката.',
          renewalFailed: 'Сървърът не може да бъде подновен. Опитайте отново.',
          passwordFailed: 'Паролата не може да бъде променена. Опитайте по-късно.',
          newPasswordFailed: 'Новата парола не може да бъде получена. Опитайте по-късно или се свържете с поддръжката.',
          passwordNotSaved: 'Паролата на сървъра може да е променена, но не е запазена. Свържете се с поддръжката.',
          insufficientRenewalFunds:
            'Недостатъчна наличност: за подновяване са необходими {{price}}. Добавете средства към баланса.',
        },
      },
    },
    security: {
      chooseConfirmationMethod: 'Изберете начин на потвърждение',
      confirmationMethod: 'Начин на потвърждение',
      choose: 'Изберете',
      resendAfter: 'Изпратете отново след {{seconds}} сек.',
      confirmation: 'Потвърждение',
      protectAccount: 'За да защитите акаунта си, изпълнете следната проверка',
      authenticationCode: 'Код за удостоверяване',
      codeSentToEmail: 'Въведете кода, който изпратихме на вашия имейл',
      enterCode: 'Въведете кода',
      invalidCode: 'Невалиден код за потвърждение',
      resendWithSeconds: 'Изпратете отново ({{seconds}} сек.)',
      resend: 'Изпратете отново',
      changeConfirmationMethod: 'Променете начина на потвърждение',
      confirm: 'Потвърди',
    },
  },
};

export default bg;
